#@import moment
#@import Booking.Models.Base
#@export Booking.Models.Time

class Booking.Models.Time extends Booking.Models.Base

  constructor: ->
    Booking.Models.Base.apply this, arguments

    initialTimeMoment = clndrTimeMoment = moment.unix(@get('initial_time'))
    finalTimeMoment = moment.unix(@get('final_time'))

    if @collection and not @collection.meta('browserInMerchantTimezone')
      initialTimeMoment = initialTimeMoment.tz(@collection.getTimezone())
      finalTimeMoment = finalTimeMoment.tz(@collection.getTimezone())

    @set {initialTimeMoment, finalTimeMoment, clndrTimeMoment}

  start: ->
    @get('initialTimeMoment')

  end: ->
    @get('finalTimeMoment')

  isSelected: ->
    @get('selected')

  isDisabled: ->
    @get('disabled')

  setSelected: (selected, disabled, options) ->
    @set {selected, disabled}, options

  select: (disabled = false, options = {}) ->
    @setSelected(true, disabled, options)

  deselect: (disabled = false, options = {}) ->
    @setSelected(false, disabled, options)

  toggle: ->
    if @isSelected()
      @deselect()
    else
      @select()
